export default {
    toastText: "Copiato!",
};
